import { isError } from '@belong/api/helpers/serviceUtils';
import { GenericAPI } from '@belong/api/services/GenericAPI';
import { IErrorResponse, INetworkResponse, PRODUCT_FAMILY } from '@belong/types';
import { FCatalogOffer } from '../factories';
import { createActivationOffersRequest, createAtlOffersRequest, createChangePlanOffersRequest } from './requests';
import { IAPIAvailableOffersResponse, IAvailableOffersResponse } from './types';

// Convert raw API offers (IOffer) to ICatalogOffer to make reward property management simpler
async function transformResponse(
  result: INetworkResponse<IAPIAvailableOffersResponse>
): INetworkResponse<IAvailableOffersResponse> {
  const { body, status, headers } = await result;

  // Just pass-through for errors
  if (isError(body)) {
    return result as INetworkResponse<IErrorResponse>;
  }

  return {
    status,
    headers,
    body: {
      ...body,
      offersToAdd: body.offersToAdd.map(FCatalogOffer)
    }
  };
}

class OffersApi extends GenericAPI {
  endpoint = '/product/v1/available-offers';
  publicEndpoint = '/product/v1/public/available-offers';

  getAtlOffers(productFamily: PRODUCT_FAMILY, gainingPlans: string[]): INetworkResponse<IAvailableOffersResponse> {
    const request = createAtlOffersRequest(productFamily, gainingPlans);
    return transformResponse(this.post(this.publicEndpoint, request, { includeCredentials: false }));
  }

  getActivationOffers(
    productFamily: PRODUCT_FAMILY,
    gainingPlans: string[],
    isPortIn?: boolean,
    simNumber?: string
  ): INetworkResponse<IAvailableOffersResponse> {
    const request = createActivationOffersRequest(productFamily, gainingPlans, isPortIn, simNumber);
    return transformResponse(this.post(this.endpoint, request));
  }

  getChangePlanOffers(
    productFamily: PRODUCT_FAMILY,
    serviceId: string,
    gainingPlans: string[],
    losingPlan: string,
    currentPlanOffers: string[]
  ): INetworkResponse<IAvailableOffersResponse> {
    const request = createChangePlanOffersRequest(
      productFamily,
      serviceId,
      gainingPlans,
      losingPlan,
      currentPlanOffers
    );
    return transformResponse(this.post(this.endpoint, request));
  }
}

export default new OffersApi();
